import { isEarningsEquity } from "./equitySymbol.js";

export function getEarningsDays(result, symbol) {
  const sym = symbol ?? result?.symbol;
  if (!isEarningsEquity(sym)) return { days: null, dateIso: null };
  const days =
    result?.earningsDaysAway ??
    result?.earnings_days ??
    result?.scanEarningsDaysAway ??
    result?.earningsState?.daysAway ??
    null;
  const dateIso =
    result?.earningsNextDate ??
    result?.earningsState?.nextDateIso ??
    result?.earnings?.date ??
    null;
  return { days: typeof days === "number" ? days : null, dateIso };
}

/** Row pill: ≤2 red, 3–10 amber; >10 and unknown → drawer only. */
export function getEarningsRowPill(result, symbol) {
  const { days } = getEarningsDays(result, symbol);
  if (days == null || days < 0) return null;
  if (days <= 2) {
    return {
      level: "red",
      text: `⚠ Earnings in ${days} day${days === 1 ? "" : "s"} — IV crush / gap risk for options`,
    };
  }
  if (days <= 10) {
    return {
      level: "amber",
      text: `Earnings in ${days} days`,
    };
  }
  return null;
}

/** Drawer-only grey lines. */
export function getEarningsDrawerLine(result, symbol) {
  const { days, dateIso } = getEarningsDays(result, symbol);
  if (!isEarningsEquity(symbol ?? result?.symbol)) return null;
  if (days == null) return { level: "grey", text: "Earnings date unknown" };
  if (days > 10) {
    const d = dateIso
      ? new Date(`${String(dateIso).slice(0, 10)}T12:00:00Z`).toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
        })
      : null;
    return { level: "grey", text: d ? `Earnings ${d}` : `Earnings in ${days} days` };
  }
  return null;
}

/** AI / context blob — mention earnings, do not use as downgrade. */
export function earningsContextForAi(result, symbol) {
  const { days, dateIso } = getEarningsDays(result, symbol);
  if (days == null) return "Upcoming earnings date: unknown (mention as context only, not a veto).";
  return `Upcoming earnings in ${days} trading day(s)${dateIso ? ` (${dateIso})` : ""} — mention IV/gap risk for options if relevant; not a reason to veto the setup.`;
}

export function computeEarningsInHold(result, entryPrice = null) {
  const { days } = getEarningsDays(result);
  if (days != null && days >= 0 && days <= 10) return true;
  const t1 = result?.t1;
  const price = entryPrice ?? result?.price;
  const atr = result?.atr;
  if (days == null || days < 0 || price == null || t1 == null) return false;
  const upsidePct = ((t1 - price) / price) * 100;
  const estDaysToT1 = atr && atr > 0 ? Math.max(5, Math.min(30, (t1 - price) / (atr * 0.5))) : 15;
  return days <= estDaysToT1;
}
